import { Zone } from './index';

export class City {
  id: number;
  name: string;
  zones: Zone[] = [];
}
